export { default } from './CollapsedPaneRail';
